import logo from './logo.svg';
import './App.css';
import Container from './components/Container';
import Header from './components/Header'
import Stack from './components/Stack'
import Contact from './components/Contact';
import Testimonial from './components/Testimonial';
import Services from './components/Services';

function App() {
  
  return (
    <div className="App">
      
      <Header/>
      <Stack/>
      <Services/>
      <Testimonial />
      <Contact/>
      
      </div>
  );
}

export default App;
